/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Drop-off Risk — viewer. */
(function () {

    function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
    function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
    function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
    function preset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
    var RANGE=(function(){try{var s=JSON.parse(localStorage.getItem("gs_dr_range")||"null");if(s&&s.preset)return preset(+s.preset);if(s&&s.from&&s.to)return s;}catch(e){}return preset(30);})();
    function _rpInit(){
      var btn=document.querySelector('[data-dr="rangeBtn"]'),menu=document.querySelector('[data-dr="rangeMenu"]'),lab=document.querySelector('[data-dr="range-label"]');
      if(!btn||!menu)return;
      if(lab&&RANGE.label)lab.textContent=RANGE.label;
      function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===RANGE.preset);});}
      btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
      document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
      function apply(r){RANGE=r;if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_dr_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";load();}
      menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(preset(+b.getAttribute("data-preset")));});});
      var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
    }


  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  var root = document.querySelector('[data-dr="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-dr="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { n = +n || 0; return n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  /* Bands describe severity without implying a probability. */
  function band(r) { return r >= 110 ? "#DC2626" : r >= 80 ? "#EA580C" : r >= 50 ? "#D97706" : "#1FA463"; }

  function heatA(p) { return '<a class="dr-ev-a" href="/heatmaps?page=' + encodeURIComponent(p) + '" title="'+TT('dor.tip_heatmap')+'"><i class="bi bi-grid-1x2-fill"></i></a>'; }
  function watchA(p) { return '<a class="dr-ev-a" href="/session-recordings?page=' + encodeURIComponent(p) + '" title="'+TT('dor.tip_watch')+'"><i class="bi bi-play-circle-fill"></i></a>'; }

  function renderPages(d) {
    var host = q("pages"); if (!host) return;
    var rows = d.pages || [];
    if (!rows.length) {
      host.innerHTML = '<div class="empty">' + esc(d.note || TR('dropof.f3.no_page_has_enough_sessions_yet_in')) + "</div>";
      return;
    }
    var max = Math.max.apply(null, rows.map(function (r) { return r.risk; }).concat([1]));
    host.innerHTML = rows.map(function (p) {
      /* The sum is spelled out: exit rate, then each penalty, then the total. */
      var sum = p.exit_rate + (p.f_penalty ? " +" + p.f_penalty + " friction" : "")
              + (p.a_penalty ? " +" + p.a_penalty + " attention" : "");
      return '<div class="dr-row" data-gs-page="' + esc(p.path) + '" title="' + esc(p.path) + '">'
        + '<a class="dr-path" href="/heatmaps?page=' + encodeURIComponent(p.path) + '">' + esc(p.path) + "</a>"
        + '<span class="dr-bar"><i style="width:' + Math.max(2, Math.round(p.risk / max * 100))
        + "%;background:" + band(p.risk) + '"></i></span>'
        + '<span class="dr-score" style="color:' + band(p.risk) + '">' + p.risk + "</span>"
        + '<span class="dr-sum">' + esc(String(sum)) + "</span>"
        + '<span class="dr-n">' + nf(p.exits) + "/" + nf(p.sessions) + " left</span>"
        + '<span class="dr-ev">' + watchA(p.path) + "</span>"
        + "</div>";
    }).join("");
  }

  function renderLeaks(d) {
    var host = q("leaks"); if (!host) return;
    var rows = (d.leaks || []).filter(function (r) { return r.lost > 0; });
    if (!rows.length) { host.innerHTML = '<div class="empty">'+TR('dropof.f2.no_exits_recorded_in_this_range')+'</div>'; return; }
    var max = Math.max.apply(null, rows.map(function (r) { return r.lost; }).concat([1]));
    host.innerHTML = rows.map(function (p) {
      return '<div class="dr-leak" data-gs-page="' + esc(p.path) + '"><span class="dr-lpath">' + esc(p.path) + "</span>"
        + '<span class="dr-lbar"><i style="width:' + Math.max(3, Math.round(p.lost / max * 100)) + '%"></i></span>'
        + '<span class="dr-lnum">' + nf(p.lost) + '</span><span class="dr-ev">' + heatA(p.path) + watchA(p.path) + "</span></div>";
    }).join("");
  }

  function renderNear(d) {
    var host = q("near"); if (!host) return;
    var rows = d.near_miss || [];
    if (!rows || !rows.length) { host.innerHTML = ""; return; }
    host.innerHTML = '<div class="dr-near-h">'+TT('dor.js.arrived_decided_and_left_anyway')+'</div>'
      + '<div class="gs-muted small dr-near-s">Sessions scoring 65+ intent whose last page was this one &mdash; '
      + "the most expensive exits you have.</div>"
      + rows.map(function (r) {
          return '<div class="dr-near-row"><span>' + esc(r.path) + "</span><b>" + nf(r.sessions)
               + '</b><em>intent ' + r.intent + '</em><span class="dr-ev">' + heatA(r.path) + watchA(r.path) + "</span></div>";
        }).join("");
  }

  function load() {
    if (!window.GS || !GS.api || !GS.site) return;
    var f = q("from"), t = q("to");
    GS.api("/plugin/dropoff-risk/overview?site=" + encodeURIComponent(GS.site)
           + "&from=" + RANGE.from + "&to=" + RANGE.to)
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        if (!d) return;
        var m = q("means"), fl = q("floor");
        if (m && d.site && d.site.mean_friction != null)
          m.textContent = " Your site averages friction " + d.site.mean_friction
                        + " and attention " + d.site.mean_attention + ".";
        else if (m && d.notes && d.notes.behaviour) m.textContent = " " + d.notes.behaviour;
        if (fl && d.site) fl.textContent = "Pages with fewer than " + d.site.min_sessions
          + " sessions are left out — a rate from three visits is an anecdote.";
        renderPages(d); renderLeaks(d); renderNear(d);
        /* Search the ranked page list first and fall back to the leak list, so a page that is only
           a leak still gets found rather than reported as absent. */
        if (window.GS && GS.applyPageDeepLink) GS.applyPageDeepLink(root, {
          within: q("pages"),
          missText: 'No drop-off data for ' + GS.dlParam("page") + ' in this range \u2014 pages under the session floor are excluded.'
        });
      })
      .catch(function (e) {
        var h = q("pages");
        if (h) h.innerHTML = '<div class="empty">Could not load drop-off risk (' + esc((e && e.message) || "request failed") + ").</div>";
      });
  }

  (function initRange() {
    function iso(d) { return d.toISOString().slice(0, 10); }
    var a = q("from"), b = q("to");
    if (a && !a.value) a.value = iso(new Date(Date.now() - 29 * 864e5));
    if (b && !b.value) b.value = iso(new Date());
    [a, b].forEach(function (el) { if (el) el.addEventListener("change", load); });
  })();

  _rpInit(); document.addEventListener("gs:ready", load, { once: true });
  if (window.GS && GS.site) load();
})();
